import { Component, Input } from '@angular/core';
import { User } from "../../../app/app.interfaces";


@Component({
  selector: 'avatar',
  templateUrl: 'avatar.html'
})
export class Avatar {  
  @Input() avatar?: string;
  @Input() firstName?: string;
  @Input() user?: User;
  @Input() anonymous: boolean = false;
  @Input() link: boolean = true;
  @Input() size: string = 'regular';
  
  imgLoadError(event){
    event.target.src = 'assets/icons/user.svg';
  }
}



// WEBPACK FOOTER //
// ./src/partials/user/avatar/avatar.ts